import { useLayoutEffect } from 'react';

import {
  isShowFallbackSelector,
  redirectPathSelector,
  titleSelector,
  usePageTitleStore,
} from './pageTitleStore';

export const usePageTitle = (
  title?: string,
  isShowFallback?: boolean,
  redirectPath?: string
) => {
  const {
    setTitle,
    setIsShowFallback,
    setRedirectPath,
    resetTitle,
    resetIsShowFallback,
    resetRedirectPath,
  } = usePageTitleStore();
  const storeTitle = usePageTitleStore(titleSelector);
  const storeIsShowFallback = usePageTitleStore(isShowFallbackSelector);
  const storeRedirectPath = usePageTitleStore(redirectPathSelector);

  useLayoutEffect(() => {
    if (title) setTitle(title);
    if (isShowFallback !== undefined) setIsShowFallback(isShowFallback);
    if (redirectPath !== undefined) setRedirectPath(redirectPath);

    return () => {
      resetTitle();
      resetIsShowFallback();
      resetRedirectPath();
    };
  }, [
    setTitle,
    setIsShowFallback,
    setRedirectPath,
    resetTitle,
    resetIsShowFallback,
    resetRedirectPath,
    title,
    isShowFallback,
    redirectPath,
  ]);

  return {
    title: storeTitle,
    isShowFallback: storeIsShowFallback,
    redirectPath: storeRedirectPath,
    setTitle,
    setIsShowFallback,
    setRedirectPath,
    resetTitle,
    resetIsShowFallback,
    resetRedirectPath,
  };
};
